import { render } from "./BravoOption.vue?vue&type=template&id=e873168e"
import script from "./BravoOption.vue?vue&type=script&lang=js"
export * from "./BravoOption.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__